import axios from 'axios'

export const fetchIcons = async () => {
  return axios.get(
    `${process.env.EDITOR_ASSETS_HOST}/assets/data/fontAwesomeProIcons(5.11.0).json`,
  )
}
